import React, { createContext, useContext, useState, useEffect, useMemo } from 'react';
import { ConfigProvider, App as AntApp } from 'antd';
import { lightTheme, darkTheme } from './themeConfig';

const ThemeContext = createContext({
  mode: 'light',
  setMode: () => {},
  toggleMode: () => {},
});

export const useThemeMode = () => useContext(ThemeContext);

export default function ThemeProvider({ children }) {
  const [mode, setMode] = useState(() => {
    const saved = localStorage.getItem('themeMode');
    if (saved) return saved;
    return window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
  });

  useEffect(() => {
    localStorage.setItem('themeMode', mode);
    document.documentElement.setAttribute('data-theme', mode);
  }, [mode]);

  const toggleMode = () => setMode((prev) => (prev === 'dark' ? 'light' : 'dark'));

  const themeConfig = useMemo(() => (mode === 'dark' ? darkTheme : lightTheme), [mode]);

  const contextValue = useMemo(() => ({ mode, setMode, toggleMode }), [mode]);

  return (
    <ThemeContext.Provider value={contextValue}>
      <ConfigProvider theme={themeConfig}>
        <AntApp>
          {children}
        </AntApp>
      </ConfigProvider>
    </ThemeContext.Provider>
  );
}
